import useAxios from 'hooks/useAxios';

export const getSuspicious = async (limit = 20, page = 1) => {
  const api = useAxios();
  try {
    const unformattedData = await api.get('/suspicious-action', {
      params: {
        limit,
        page
      }
    });
    return {
      data: unformattedData.data.data.map((x) => {
        return {
          ...x,
          player: x.player.username || '-',
          data: x?.data !== null ? JSON.stringify(x.data) : '-'
        };
      }),
      meta: unformattedData.data.meta
    };
  } catch {
    return {
      data: [],
      meta: {
        totalItems: 0,
        itemCount: 0,
        itemsPerPage: 0,
        totalPages: 0,
        currentPage: 0
      }
    };
  }
};

export const getSuspiciousSinge = async (id) => {
  const api = useAxios();
  try {
    return await api.get(`/suspicious-action/${id}`);
  } catch (err) {
    return err;
  }
};
